<template lang="pug">
  nav.navbar.is-light(role='navigation' aria-label='main navigation')
    .navbar-brand
      a.navbar-item(to="/")
        img#logoBrand(src='@/assets/ducter_color.png')
      a#navBurger.navbar-burger.burger(role='button' aria-label='menu' aria-expanded='false' data-target='navbarMenu' @click="displayBurger")
        span(aria-hidden='true')
        span(aria-hidden='true')
        span(aria-hidden='true')
    #navbarMenu.navbar-menu
      .navbar-start
        a.navbar-item(@click="irToHome")
          .buttons
            i.fas.fa-home
            | &nbsp Home
      .navbar-end
        .navbar-item.has-dropdown.is-hoverable
          .navbar-item(v-show="isIRGE || isAdmin")
            .buttons
              a.button.is-dark
                | Menú &nbsp
                i.fas.fa-bars
          #moreDropdown.navbar-dropdown(v-show="isIRGE || isAdmin")
            router-link.a.navbar-item(v-show="this.permisos.sca_irge != 7" to="/IRGE/SCA/Documentacion/Nuevo")
              .level.is-mobile
                .level-left
                  .level-item
                    p
                      strong Documentación
                      br
                      i.fas.fa-file-pdf
                      small &nbspCarta Porte
            router-link.a.navbar-item(to="/IRGE/SCA/Documentacion/Reportes")
              .level.is-mobile
                .level-left
                  .level-item
                    p
                      strong Reportes
                      br
                      i.fas.fa-clipboard-list
                      small &nbspGenerar Reportes
            router-link.a.navbar-item(to="/IRGE/SCA/Documentacion/")
              .level.is-mobile
                .level-left
                  .level-item
                    p
                      strong Capturas
                      br
                      i.fas.fa-database
                      small &nbspRegistros realizados
            router-link.a.navbar-item(v-show="this.permisos.sca_irge != 7" to="/IRGE/SCA/Documentacion/Configuracion")
              .level.is-mobile
                .level-left
                  .level-item
                    p
                      strong Catálogo
                      br
                      i.fas.fa-tags
                      small &nbspPorteadores, Destinos...
            router-link.a.navbar-item(to="/IRGE/SCA/Documentacion/Entradas")
              .level.is-mobile
                .level-left
                  .level-item
                    p
                      strong Entradas / Cargas
                      br
                      i.fas.fa-truck-moving
                      small &nbspEntradas, Cargas
            router-link.a.navbar-item(to="/IRGE/SCA/Documentacion/Buscar")
              .level.is-mobile
                .level-left
                  .level-item
                    p
                      strong Búsquedas
                      br
                      i.fas.fa-search
                      small &nbspPor PG, Fecha
            router-link.a.navbar-item(to="/Directorio")
              .level.is-mobile
                .level-left
                  .level-item
                    p
                      strong Directorio
                      br  
                      small Directorio Telefónico
                .level-right
                  .level-item
                    span.icon.has-text-success
                      i.fas.fa-phone
        .navbar-item
          a.button.is-dark
            | {{ userLogin.nombre }}
          .navbar-item
            a.button.is-dark(@click="salirSistema")
              | Salir &nbsp
              i.fas.fa-door-open
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
export default {
  name: 'NavBarSca',
  data () {
    return {
      isTPA: false,
      isIRGE: false,
      isAdmin: false,
      documentadosBD: []
    }
  },
  methods: {
    obtenerUser() {
      if (Object.keys(this.userLogin).length === 0) {
        this.$router.push('/')
      } else {
        console.log('Es un usuario logueado')
        switch (this.userLogin.ubicacion) {
          case 'ALL':
            this.isAdmin = true
            break
          case 'TPA':
            this.isTPA = true
            break
          case 'IRGE':
            this.isIRGE = true
            break
        
          default:
            this.isIRGE = this.permisos.sca_irge != 2
            break
        }
      }
    },
    displayBurger () {
      let burger = document.getElementById('navBurger')
      let nav = document.getElementById(burger.dataset.target)
      burger.classList.toggle('is-active')
      nav.classList.toggle('is-active')
    },
    salirSistema () {
      sessionStorage.clear()
      this.$store.commit('setlogin', false)
      this.$store.commit('usuarioLogueado', {})
      this.$router.push('/')
    },
    irToHome () {
      if (this.userLogin.cargo === '345') {
        this.$router.push('/Externo')
      } else {
        switch (this.userLogin.ubicacion) {
          case 'IRGE':
            this.$router.push('/IRGE')
            break;
          case 'TPA':
            this.$router.push('/TPA')
            break;
          case 'EB00':
            this.$router.push('/Estacion')
            break;
          case 'EB01':
            this.$router.push('/Estacion')
            break;
          case 'EB02':
            this.$router.push('/Estacion')
            break;
          case 'EB03':
            this.$router.push('/Estacion')
            break;
          case 'EB04':
            this.$router.push('/Estacion')
            break;
          case 'CORP':
            this.$router.push('/Corporativo')
            break;
          case 'ALL':
            this.$router.push('/Admin')
            break;
          case 'EXT':
            this.$router.push('/Externo')
            break      
          default:
            this.$router.push('/')
            break;
        }
      }
    }
  },
  created() {
    this.obtenerUser()
  },
  computed: {
    ...mapState(['logueado', 'userLogin', 'permisos'])
  }
  // mounted () {
  //   this.userSeguridad = Object.assign({}, this.userSeguridad, this.userLogin)
  // }
}
</script>

<style lang="css">
  #logoBrand {
    max-width: 150px;
  }

  .navbar-item img {
    max-height: 100%;
  }

  .navbar.is-light {
    height: 80px;
  }

</style>




// WEBPACK FOOTER //
// src/components/sca_Componentes/layout/irge/NavBarSca.vue